const PATH_PANELS = [
  ['how-soon', 'name-panel', 'zip-panel', 'email-panel', 'phone-panel'],
  ['account-email-panel', 'account-panel']
];

/*
  Enables the inputs for the current active path; disables those in other paths.
  This ensures that the fields in that path will not be validated or submitted with the form.
 */
export default function enablePathInputs(form, activePath) {
  PATH_PANELS.forEach((paths, index) => {
    paths.forEach((path) => {
      const panel = form.querySelector(`.lead-constructor__panel[data-id="${path}"]`);
      if(panel) {
        [...panel.querySelectorAll('input')].forEach((input) => {
          input.disabled = index !== activePath;
        });
      }
    });
  });
}
